export const chapters = [
  {
    id: 2,
    part: 1,
    englishTitle: "Leaf 16",
    kanjiTitle: "tbd",
    romanizedTitle: "tbd",
    available: false,
    content: `Content for Leaf 16...`,
 }
];